import request from "@/utlis/request";
import {findVipUserListByGroupIds} from "@/api/AuctionManage";

/**
 * 分页获取其他报价信息
 */
export function findOfferOtherListPage(data) {
    return request({
        url: "/admin/offer/findOfferOtherListPage",
        method: "post",
        timeout: 150000, // 请求超时时间
        data,
    });
}

/**
 * 提交报价
 */
export function submitOffer(data) {
    return request({
        url: "/admin/quotations/bid",
        method: "post",
        timeout: 300000, // 请求超时时间
        data,
    })
        .then((res) => {
            console.log(res);
            return res;
        })
        .catch((error) => {
            // 超时是响应为 “第三方网站暂无响应”
            if (error.message === "timeout of 300000ms exceeded") {
                return {
                    success: false,
                    message: "第三方网站暂无响应",
                };
            }
            return error;
        });
}

/**
 * 查询报价信息列表
 */
export function findQuotationsList(params) {
    return request({
        url: "/admin/quotations/list",
        method: "GET",
        params,
    });
}

export function findQuotationsList2(params) {
    return request({
        url: "/admin/quotations/list2",
        method: "GET",
        params,
    });
}

/**
 * 选取报价
 */
export function handleQuotationsBid(data) {
    return request({
        url: "/admin/quotations/bid",
        method: "post",
        data,
    });
}

/**
 * 取消报价
 */
export function handleQuotationsUnbid(data) {
    return request({
        url: "/admin/quotations/unbid",
        method: "PUT",
        data,
    });
}

/**
 * 会员中标信息
 */
export function quotationsBidInfo(params) {
    return request({
        url: "/admin/quotations/bid-info",
        method: "GET",
        params,
    });
}

/**
 * 期车转委托
 */
export function offerOffer2entrust(data) {
    return request({
        url: "/admin/offer/offer2entrust",
        method: "post",
        data,
    });
}

/**
 * 期车转委托
 */
export function offerOffer2entrustMP(data) {
    return request({
        url: "/admin/offer/offer2entrustMP",
        method: "post",
        data,
    });
}

/**
 * 查询app、内网会员
 */
export function findQuotationsListTop5(params) {
    return request({
        url: "/admin/quotations/list-top5",
        method: "GET",
        params,
    });
}

/**
 * 车300查询接口
 */
export function get300Info(params) {
    return request({
        url: "/admin/quotations/get300Info",
        method: "GET",
        params,
    });
}

export function modifyVin(params) {
    return request({
        url: "/admin/quotations/modifyVin",
        method: "GET",
        params,
    });
}


export function getSearchLog(params) {
    return request({
        url: "/admin/quotations/getSearchLog",
        method: "GET",
        params,
    });
}

export function getSearchLog2(params) {
    return request({
        url: "/admin/quotations/getSearchLog2",
        method: "GET",
        params,
    });
}

export function getSearchInfo(params) {
    return request({
        url: "/admin/quotations/getSearchInfo",
        method: "GET",
        timeout: 30000, // 请求超时时间
        params,
    });
}

export function addAndModifyGroup(params) {
    return request({
        url: "/admin/quotations/addAndModifyGroup",
        method: "GET",
        params,
    });
}

export function listGroup(params) {
    return request({
        url: "/admin/quotations/listGroup",
        method: "GET",
        params,
    });
}

export function getGroupUserById(params) {
    return request({
        url: "/admin/quotations/getGroupUserById",
        method: "GET",
        params,
    });
}

export function removeGroupUserById(params) {
    return request({
        url: "/admin/quotations/removeGroupUserById",
        method: "GET",
        params,
    });
}

export function listGroupIdsByCarId(params) {
    return request({
        url: "/admin/quotations/listGroupIdsByCarId",
        method: "GET",
        params,
    });
}


export function GetUserSearchLogList(data) {
    return request({
        url: "/admin/quotations/getUserSearchLogList",
        method: "post",
        timeout: 150000, // 请求超时时间
        data,
    });
}


export function getTJBJSJ(data) {
    return request({
        url: "/admin/quotations/getTJBJSJ",
        method: "post",
        data,
    });
}

export function getAllCarUpbeat(startTime,endTime,institutionId) {
    return request({
        url: "/admin/upbeat/getAllCarUpbeat",
        method: "get",
        params: {
            startTime: startTime,
            endTime: endTime,
            institutionId: institutionId,
        },
    });
}

export function getAllYJ(startTime,endTime,institutionId) {
    return request({
        url: "/admin/upbeat/getAllYJ",
        method: "get",
        params: {
            startTime: startTime,
            endTime: endTime,
            institutionId: institutionId,
        },
    });
}

